import React, { KeyboardEvent, useEffect, useState } from "react";
import { Translations } from "../../../models/translations";
import { FormikFieldProps } from "../../framework/formUtils";
import { AutocompleteOption, AutocompleteWrapper } from "../../framework/muiAutocomplete";
import { useAppDispatch, useAppSelector } from "../../../framework/customStore";
import { fetchEmployees } from "../../../store/employeeSlice";

interface DriverSelectProps extends Partial<FormikFieldProps> {
    value?: string | string[] | null;
    small?: boolean;
    required?: boolean;
    multiple?: boolean;
    open?: boolean;
    defaultOpen?: boolean;
    label?: string;
    autoFocus?: boolean;
    disabled?: boolean;
    onChange?: (id: string | string[] | null, title?: string | null) => void;
    onBlur?: (e: any) => void;
    onKeyDown?: (e: KeyboardEvent) => void;
}

export const DriverSelect = (props: DriverSelectProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const {
        value,
        small,
        onChange,
        onBlur,
        onKeyDown,
        multiple,
        open,
        autoFocus,
        defaultOpen,
        ...rest
    } = props;
    const employees = useAppSelector((state) => state.employees.employees);

    useEffect(() => {
        if(employees?.length === 0) {
            setLoading(true);
            dispatch(fetchEmployees() as any);
        } else {
            setLoading(false);
        }
    }, [employees]);

    const handleChange = (val: AutocompleteOption | AutocompleteOption[] | null) => {
        if (Array.isArray(val)) {
            onChange(val.map(v => v.id));
        } else {
            onChange(val?.id ?? null, val?.title);
        }
    };

    return (
        <AutocompleteWrapper
            label={props.label || Translations.Employee}
            value={value ?? ""}
            size={small ? "small" : "medium"}
            options={employees && employees.map(e =>({ id: e.id, title: `${e.firstName} ${e.lastName}` })) }
            onChange={handleChange}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            loading={loading}
            required={props.required}
            multiple={multiple}
            open={open}
            autoFocus={autoFocus}
            textFieldProps={{ ...rest }}
            disabled={props.disabled}
            defaultOpen={defaultOpen}
        />
    );
};
